import type { ItemProps } from "@bedrock/domain";
import { Icon } from "@bedrock/ui";
import { PdfViewer } from "./pdf-viewer";
import { SpreadsheetViewer } from "./spreadsheet-viewer";
import { VideoPlayer } from "./video-player";

type MediaProps = Extract<ItemProps, { kind: "image" | "video" | "pdf" | "spreadsheet" }>;

export function CanvasMedia({ props }: { props: MediaProps }) {
  if (props.kind === "image") {
    return <figure className="item-image">{props.localUrl ? <img src={props.localUrl} alt={props.alt} draggable={false}/> : <div className="media-placeholder"><Icon name="image"/></div>}<figcaption>{props.filename}</figcaption></figure>;
  }
  if (props.kind === "video") return <div className="item-video"><VideoPlayer src={props.localUrl} filename={props.filename} variant="canvas"/></div>;
  if (props.kind === "spreadsheet") {
    const format = props.mimeType === "application/vnd.ms-excel" ? "XLS" : "XLSX";
    return <figure className="item-spreadsheet"><SpreadsheetViewer props={props} variant="canvas"/><figcaption><span>{format}</span><strong>{props.filename}</strong></figcaption></figure>;
  }
  return <figure className="item-pdf"><PdfViewer props={props} variant="canvas"/><figcaption><span>PDF</span><strong>{props.filename}</strong></figcaption></figure>;
}
